import CONSTANTS from "constants/Constants";
import tagConstants from "constants/Tag";
import { FORM_MODES } from "routes/contact/form/defaults";

export const MODEL_TYPE = "Contact";
export const TAG_MODEL_TYPE = tagConstants.taggableModels.contact;

export const PAGE_TITLES = {
  [FORM_MODES.create]: "Create Contact",
  [FORM_MODES.edit]: "Edit Contact",
};

export const BREADCRUMB_LABELS = {
  [FORM_MODES.create]: "New",
  [FORM_MODES.edit]: "Edit",
};

export const SUCCESS_MESSAGES = {
  [FORM_MODES.create]: "Contact created",
  [FORM_MODES.edit]: "Contact updated",
};

export const PHONE_TYPE_OPTIONS = [
  {
    key: "mobile",
    value: CONSTANTS.CONTACT_PHONE_TYPES.MOBILE,
    text: "Mobile",
  },
  { key: "work", value: CONSTANTS.CONTACT_PHONE_TYPES.WORK, text: "Work" },
  { key: "home", value: CONSTANTS.CONTACT_PHONE_TYPES.HOME, text: "Home" },
  { key: "other", value: CONSTANTS.CONTACT_PHONE_TYPES.DEFAULT, text: "Other" },
];
